export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6949.9e4eb884.jpg";